import PolicyStore from '../../policy/store/PolicyStore';

class FlowServices {
  constructor(modalityType = '') {
    this.modalityType = modalityType;

    const flow = this.getStepFlowByModality();
    this.flow = flow;
  }

  getPreviousStep(actualPath) {
    const pathIndex = this.getActualPathIndex(actualPath);
    return this.flow[pathIndex - 1];
  }

  getNextStep(actualPath) {
    const pathIndex = this.getActualPathIndex(actualPath);
    return this.flow[pathIndex + 1];
  }

  getActualPathIndex(actualPath) {
    return this.flow.findIndex(_path => {
      return _path.path === actualPath;
    });
  }

  finishCurrentStep(currentPath) {
    const currentFlow = this.flow;
    const index = currentFlow
      .map(step => {
        return step.path;
      })
      .indexOf(currentPath);

    currentFlow[index].finished = true;
  }

  previousStepWasFinished(actualPath) {
    const previousStep = this.getPreviousStep(actualPath);

    if (!previousStep) {
      return true;
    }

    const previousFlowStep = this.getFlowStep(previousStep.path);
    return previousFlowStep ? previousFlowStep.finished : false;
  }

  getFlowStep(path) {
    const flowStep = this.flow.filter(step => {
      return step.path === path;
    });

    return flowStep[0];
  }

  goToNextStep(history, location) {
    const { pathname } = location;

    const { path } = this.getNextStep(pathname);

    history.push(path);
  }

  getStepFlowByModality() {
    let flow;

    /* istanbul ignore next  */
    switch (this.modalityType) {
      case 'judicial':
        flow = require('../json/flow/judicial.json');
        break;
      case 'executante-construtor':
      case 'executante-prestador-de-servicos':
      case 'executante-fornecedor':
      case 'performance':
      case 'contrato':
        flow = require('../json/flow/performance.json');
        PolicyStore.InicioVigencia = '';
        break;
      case 'Licitante':
      case 'licitante':
      case 'licitacao':
        flow = require('../json/flow/licitante.json');
        PolicyStore.InicioVigencia = '';
        break;
      case 'civel':
      case 'tributaria':
      default:
        flow = require('../json/flow/default.json');
        break;
    }

    return flow;
  }
}

export default FlowServices;
